import { Box, Chip, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';

class ByFirstRespon extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"By First Respon"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.contactLeads?.map(group => {
                            return (
                                    <Paper elevation={2} sx={{mb: "10px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>{group.salesName}</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"}><strong>{group.leadsCount} leads</strong></Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            {/* <Grid item xs={4}>
                                                <Box>Average</Box>
                                                <Box>{Global.formatTime(group.avgResponseTime)}</Box>
                                            </Grid> */}
                                            <Grid item xs={6} textAlign={"left"}>
                                                <Chip size='small' label={`Kurang dari 1 Menit : ${group.totalUnderOneMinute}`} />
                                                <Box></Box>    
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"}>
                                                <Chip size='small' label={`Lebih dari 1 Menit : ${group.totalHigherOneMinute}`} />
                                                <Box></Box>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default ByFirstRespon;